<template>
  <v-card class="mx-auto my-4 pa-4" outlined>
    <v-card-title class="text-h6 font-weight-bold"
      >Últimas Pesagens</v-card-title
    >
    <base-data-table
      :headers="headers"
      :items="ultimasPesagens"
      hide-default-footer
      dense
      class="elevation-1 small custom-table tabela-supervisorio"
      :style="{ '--table-font-size': fontSize + 'px' }"
      :maxHeight="'500px'"
    >
      <template slot="item.status" slot-scope="{ item }">
        <div class="d-flex align-center">
          <v-badge
            dot
            inline
            :color="item.peso_liquido == null ? 'green' : 'orange'"
            class="mr-2 mb-1"
          ></v-badge>
          <span class="font-weight-medium">{{ item.status }}</span>
        </div>
      </template>
      <template slot="item.peso_entrada" slot-scope="{ item }">
        {{ item.peso_entrada ? formatarPeso(item.peso_entrada) : 0 }}
      </template>
      <template slot="item.peso_saida" slot-scope="{ item }">
        {{ item.peso_saida ? formatarPeso(item.peso_saida) : 0 }}
      </template>
      <template slot="item.peso_liquido" slot-scope="{ item }">
        {{ item.peso_liquido ? formatarPeso(item.peso_liquido) : 0 }}
      </template>
      <template slot="item.ticket_imprimir" slot-scope="{ item }">
        <v-btn
          icon
          medium
          color="primary"
          @click="handleReimprimirTicket(item)"
        >
          <v-icon medium>mdi-printer</v-icon>
        </v-btn>
      </template>
      <template slot="item.pdf" slot-scope="{ item }">
        <v-btn icon medium color="primary" @click="imprimirPDFPesagem(item)">
          <v-icon medium>mdi-download</v-icon>
        </v-btn>
      </template>
    </base-data-table>
  </v-card>
</template>

<script>
import { BasicPermissions, Sequences } from '@/utils/permissions'
import { mapActions, mapState, mapMutations } from 'vuex'
import BaseDataTable from '@/components/commonComponents/BaseDataTable'
import { mqtt_mixin } from '@/mixins/mqtt'

export default {
  inject: {
    imprimirPDF: {
      from: 'visualizarComprovantePesagem',
    },
  },
  mixins: [mqtt_mixin],
  components: { BaseDataTable },
  data() {
    return {
      headers: [
        {
          text: 'Data / Hora',
          value: 'data',
          habilited: false,
          block: false,
          divider: true,
          class: 'primary white--text',
        },
        {
          text: 'Agendamento',
          value: 'ticket',
          habilited: false,
          block: false,
          divider: true,
          class: 'primary white--text',
        },
        {
          text: 'Placa',
          value: 'placa',
          habilited: false,
          block: false,
          divider: true,
          class: 'primary white--text',
        },
        {
          text: 'Operação',
          value: 'servico',
          habilited: false,
          block: false,
          divider: true,
          class: 'primary white--text',
        },
        {
          text: 'Status',
          value: 'status',
          habilited: false,
          block: false,
          divider: true,
          class: 'primary white--text',
        },
        {
          text: 'Peso Entrada (KG)',
          value: 'peso_entrada',
          habilited: false,
          block: false,
          divider: true,
          class: 'primary white--text',
        },
        {
          text: 'Peso Saída (KG)',
          value: 'peso_saida',
          habilited: false,
          block: false,
          divider: true,
          class: 'primary white--text',
        },
        {
          text: 'Peso Líquido (KG)',
          value: 'peso_liquido',
          habilited: false,
          block: false,
          divider: true,
          class: 'primary white--text',
        },
        {
          text: 'Ticket',
          value: 'ticket_imprimir',
          habilited: false,
          block: false,
          divider: true,
          class: 'primary white--text',
        },
        {
          text: 'PDF',
          value: 'pdf',
          habilited: false,
          block: false,
          divider: true,
          class: 'primary white--text',
        },
      ],
    }
  },
  props: {
    fontSize: {
      type: Number,
      required: false,
      default: 14,
    },
  },
  methods: {
    ...mapMutations('agendamentos', ['ATUALIZA_AGENDAMENTO']),
    ...mapActions('patio', [
      'getAllAgendamentosByParams',
      'getItensLaudoCheckList',
      'getAgendamentoGerenciamentoServico',
    ]),
    ...mapActions('template', ['successMessage', 'errorMessage']),
    formatarPeso(valor) {
      if (!valor && valor !== 0) return '-'
      return valor.toLocaleString('pt-BR')
    },
    async handleReimprimirTicket(item) {
      try {
        const agendamento = await this.getAgendamentoGerenciamentoServico({
          public_id: item.agendamento,
        })
        let topic = `${this.topic}/printerTicket`
        this.publish(agendamento.impressoes, topic)
        this.successMessage('Ticket impresso com sucesso!')
      } catch (error) {
        console.error('Erro ao reimprimir o ticket:', error)
        this.errorMessage('Erro ao reimprimir o ticket.')
      }
    },
    async imprimirPDFPesagem(item) {
      const agendamento = await this.getAgendamentoGerenciamentoServico({
        public_id: item.agendamento,
      })
      this.ATUALIZA_AGENDAMENTO(agendamento)
      this.imprimirPDF()
    },
  },
  computed: {
    ...mapState('auth', ['user', 'empresaAtual']),
    ...mapState('supervisorio', ['gates', 'ultimasPesagens']),
    permission() {
      return Sequences.GerenciamentoServico.toString()
    },
    canList() {
      return this.$canDo(BasicPermissions.VISUALIZAR, this.permission)
    },
  },
  created() {
    if (['00000000000001', '15011519000223'].includes(this.empresaAtual.cnpj)) {
      this.connectMqtt(this.readMesage)
    }
  },
  watch: {
    'empresaAtual.public_id': {
      handler() {
        this.disconnectMqtt()
      },
    },
  },
}
</script>

<style scoped>
.tabela-supervisorio >>> thead th {
  background-color: #00113a !important;
  color: white !important;
  font-weight: bold !important;
}
.tabela-supervisorio >>> tbody td {
  height: 40px !important;
}
::v-deep .custom-table tbody td,
::v-deep .custom-table tbody th {
  font-size: var(--table-font-size) !important;
}
::v-deep .custom-table .v-icon {
  font-size: calc((24px - 14px) + var(--table-font-size)) !important;
}
::v-deep .custom-table .v-chip {
  font-size: calc((13px - 14px) + var(--table-font-size)) !important;
  height: calc((32px - 14px) + var(--table-font-size)) !important;
  line-height: calc((32px - 14px) + var(--table-font-size));
  padding: 0 calc((12px - 14px) + var(--table-font-size));
}

::v-deep .custom-table .v-chip .v-icon {
  font-size: calc((24px - 14px) + var(--table-font-size)) !important;
}
</style>
